<template>
  <modal name="result-modal"
         @closed="$emit('updateComparisonData')"
         @before-close="beforeClose"
         @before-open="beforeOpen"
         style="z-index: 1001;">
    <div id="modal-header" class="w-100 px-4 py-2 position-relative"
         style="background-color:#1e7bb7">
      <div class="w-100 d-flex">
        <h4 class="text-white">Ընթացակարգի արդյունքները</h4>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 30%"
              @click="$modal.hide('result-modal')" aria-label="Close">
        <span aria-hidden="true" class="text-white">&times;</span>
      </button>
    </div>
    <div id="modal-body" class="p-4" style="overflow-x: auto; height: 95%">
      <div v-if="organizedLots.length" class="responsive-table">
        <template v-if="organize.winner_by_lots">
          <table class="participants-table table table-bordered table-hover m-0" style="border-collapse: collapse; border-spacing: 0; width: 100% !important;">
            <thead>
              <tr>
                <th rowspan="2" style="width: 120px; border-right: 3px solid #dfdfdf; border-left: 3px solid #dfdfdf;">Չ/Հ</th>
                <th rowspan="2" style="border-right: 3px solid #dfdfdf;">CPV կոդ</th>
                <th rowspan="2" style="border-right: 3px solid #dfdfdf;">Գնման առարկայի անվանում</th>
                <th rowspan="2" style="border-right: 3px solid #dfdfdf;">Նախահաշվային ընդհանուր գին</th>
                <th colspan="3" style="border-right: 3px solid #dfdfdf;">Նվազագույն գնային առաջարկ (ՀՀ դրամ)</th>
                <th rowspan="2" style="border-right: 3px solid #dfdfdf;">Մասնակիցների քանակ</th>
                <th rowspan="2" style="border-right: 3px solid #dfdfdf;">Հաղթող Մասնակից</th>
                <!-- <th rowspan="2">Մասնակցի կարգավիճակ</th> -->
              </tr>
              <tr>
                <th style="border-right: 1px solid #dfdfdf;">Արժեք</th>
                <th style="border-right: 1px solid #dfdfdf;">ԱԱՀ</th>
                <th style="border-right: 3px solid #dfdfdf;">Ընդհանուր</th>
              </tr>
            </thead>
            <tbody id="comparison-table" style="min-height: 5vh; max-height: 40vh !important; overflow: scroll">
              <tr v-for="lot in organizedLots" :key="lot.id">
                <td style="border-right: 3px solid #dfdfdf; border-left: 3px solid #dfdfdf;">{{ lot.view_id }}</td>
                <td style="border-right: 3px solid #dfdfdf;">{{ lot.cpv_code }}{{ lot.cpv_drop && '/' }}{{ lot.cpv_drop }}</td>
                <td style="border-right: 3px solid #dfdfdf;">{{ lot.cpv_name }}</td>
                <td style="border-right: 3px solid #dfdfdf;">{{ lot.count * lot.unit_amount }}դր.</td>
                <template v-if="lot.participants.length">
                  <td style="border-right: 1px solid #dfdfdf;">{{ getMinPrice(lot) }}</td>
                  <td style="border-right: 1px solid #dfdfdf;">{{ getMinVat(lot) }}</td>
                  <td style="border-right: 3px solid #dfdfdf;"><b>{{ getMinPriceVat(lot) }}</b></td>
                </template>
                <template v-else>
                  <td style="border-right: 3px solid #dfdfdf;">-</td>
                  <td style="border-right: 3px solid #dfdfdf;">-</td>
                  <td style="border-right: 3px solid #dfdfdf;">-</td>
                </template>
                <td style="border-right: 3px solid #dfdfdf;">{{ lot.participants_list.length }}</td>
                <td style="border-right: 3px solid #dfdfdf;">
                  <template v-if="lot.winners.length">
                    <span :class="isMine(winner, lot) && 'font-weight-bold'" v-for="(winner, index) in lot.winners" :key="index">
                      {{ winner.name.hy }}
                    </span>
                  </template>
                  <template v-else-if="lot.participants.length">
                    <span :class="lot.participants[0].email === me.email && 'font-weight-bold'">
                      {{ lot.participants[0].name.hy }}
                    </span>
                  </template>
                  <template v-else>
                    <span>Չկա մասնակից</span>
                  </template>
                  <div>
                    <div class="dropdown" style="position: inherit; left: 0; right: 0;" v-if="lot.participants.length">
                      <span id="participant-list"
                            class="text-primary"
                            style="cursor: pointer"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false">
                            Բոլոր Մասնակիցները
                        <i class="fas fa-angle-down"></i>
                      </span>
                      <div class="dropdown-menu" style="z-index: 9999" aria-labelledby="participant-list">
                        <p v-for="(participant, index) in lot.participants_list" :key="index" :class="participant.email === me.email && 'font-weight-bold'" class="dropdown-item m-0">
                          {{ participant.info.name.hy }} - {{ getCurrPrice(participant) }}դր.
                        </p>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </template>
        <template v-else>
          <table class="participants-table table table-bordered table-hover m-0" style="border-collapse: collapse; border-spacing: 0; width: 100% !important;">
            <thead>
              <tr>
                <th style="border-right: 3px solid #dfdfdf;">Անուն</th>
                <th style="border-right: 3px solid #dfdfdf;">Ներկայացված ընդհանուր գին</th>
              </tr>
              <tr>
                <th colspan="2" style="border-right: 3px solid #dfdfdf;">Հաղթող</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {{winner.name}}
                </td>
                <td>
                  {{winner.won_lots[0].offer.total_price}}դր.
                </td>
              </tr>
            </tbody>
            <thead>
              <tr>
                <th colspan="2" style="border-right: 3px solid #dfdfdf;">Բոլոր Մասնակիցներ</th>
              </tr>
            </thead>
            <tbody id="comparison-table" style="min-height: 5vh; max-height: 40vh !important; overflow: scroll">
              <tr v-for="participant in participants" :key="participant.id">
                <td>
                  {{participant.info.name.hy}}
                </td>
                <td>
                  {{participant.total_price}}դր.
                </td>
              </tr>
            </tbody>
          </table>
        </template>
      </div>
      <div v-else>
        <div class="text-center p-3">
          <h5 class="font-size-24 m-3">Մասնակիցներ չլինելու պատճառով տվյալ գնման ընթացակարգը չի կայացել</h5>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'ResultModal',
  data () {
    return {
      isSetEqual: false,
      isSuccess: true,
      isResponded: false,
      isNewParticipant: true,
      lotsWithError: [],
      participants: [],
      winner: {},
      client: {},
      columns: ['id', 'product', 'cpv', 'count', 'unit', 'priceUnit', 'priceAll', 'price', 'vat', 'total'],
      organize: {},
      data: [],
      organizedLots: [],
      attachedLotsForParticipant: [],
      focusedLotFields: {},
      lotsWithVatLength: 0,
      sugesstion: {},
      options: {
        sortable: [],
        columnsDropdown: false,
        filterByColumn: false,
        dateFormat: "YYYY-mm-dd",
        headings: {
          id: 'Չ/Հ',
          product: 'Գնման առարկա',
          cpv: 'CPV կոդ',
          count: 'Քանակ',
          unit: 'Չափման միավոր',
          price: 'Արժեք',
          priceUnit: 'Նախահաշվային միավոր գին',
          priceAll: 'Նախահաշվային ընդհանուր գին',
          vat: 'ԱԱՀ',
          total: 'Ընդամենը'
        },
        filterable: false
      },
    }
  },
  computed: {
    me() {
      return this.$store.getters['user/me']
    },
  },
  methods: {
    consoleLog(data){
      console.log(data)
    },
    isMine(winner, lot){
      const winnerInfo = lot.participants_list.find(item => item.row_group_id === winner.participant_group_id);
      if(winnerInfo){
        const currentWinnerInfo = winnerInfo.user_info;
        return currentWinnerInfo.id === this.me.id
      } else {
        return false;
      }
    },
    beforeClose(){
      if(!this.organize.winner_by_lots){
        this.data.pop()
      }
    },
    beforeOpen({params}) {
      this.client = params.client
      this.resetComponent = params.resetComponent
      this.currSuggestionId = params.id
      this.organize = params.organize
      this.organizedLots = []
      if(this.organize.organize_rows.length){
        this.participants = this.organize.organize_rows[0].participants_list;
      }
      this.winner = this.organize.winners[0];
      console.log(this.winner)
      params.organize.organize_rows.forEach((element) => {
        const rowItem = {...element}
        rowItem.participants = element.participants.sort((a, b) => a.current_price_vat - b.current_price_vat).sort((a, b) => b.winner - a.winner);
        rowItem.winners = element.participants.filter(item => item.winner === true);
        rowItem.participants = element.participants.sort((a, b) => b.winner - a.winner);
        rowItem.satisfactory_participants = element.participants.filter((item) => item.is_satisfactory);
        this.organizedLots.push(rowItem);
      })
      this.$client.get(`suggestions/getByOrganizeId/${this.organize.id}`).then(({data}) => {
        if(data.participant){
          this.participant = data.participant
          this.isNewParticipant = false;
        }
        this.isResponded = Boolean(data.responded);
      })
      this.cleanData = this.organize.organize_rows
      this.data = this.organize.organize_rows
      if(!this.organize.winner_by_lots){
        if(this.data[this.data.length-1].is_total !== true){
          this.data.push({
            cpv_name: 'Ընդամենը',
            is_total: true
          })
        }
      }
      this.data.forEach((lot) => {
        if(lot.offers){
          const currUserOffer = lot.offers.find(item => item.participant_id ===  this.me.id);
          if(currUserOffer){
            lot.value = currUserOffer.value
            lot.overall = currUserOffer.cost
            lot.vat = currUserOffer.vat
            lot.is_with_vat = currUserOffer.vat ? 1 : 0
          }
        }
      })
    },
    roundTwoDigits(number){
      return Math.round(number * 100) / 100
    },
    getCurrPrice(participant){
      var currentPrice = participant.cost;
      return this.roundTwoDigits(currentPrice)
    },
    getMinPrice(lot){
      var winner = {}
      if(lot.winners.length){
        winner = lot.winners[0]
      } else {
        winner = lot.participantsList[0]
      }
      var currentPrice = winner.current_price;
      return this.roundTwoDigits(currentPrice)
    },
    getMinVat(lot){
      var winner = {}
      if(lot.winners.length){
        winner = lot.winners[0]
      } else {
        winner = lot.participantsList[0]
      }
      var currentVat = winner.current_vat;
      return this.roundTwoDigits(currentVat)
    },
    getMinPriceVat(lot){
      var winner = {}
      if(lot.winners.length){
        winner = lot.winners[0]
      } else {
        winner = lot.participantsList[0]
      }
      var currentPriceVat = winner.current_price_vat;
      return this.roundTwoDigits(currentPriceVat)
    },
  }
}
</script>
<style scoped>
  /deep/ .vm--modal {
    top: 3rem !important;
    left: unset !important;
    width: 80% !important;
    /* height: auto !important; */
    margin: auto;
    padding-bottom: 70px;
    -webkit-border-radius: .3rem !important;
    -moz-border-radius: .3rem !important;
    border-radius: .3rem !important;
  }
  .searchItem:hover {
    background-color: #1e7bb7;
    color: #fff;
  }
  .component-fade-enter-active, .component-fade-leave-active {
    transition: opacity .2s ease;
  }
  .component-fade-enter, .component-fade-leave-to
    /* .component-fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>

